var _g, _polygon, _polygon2, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 1.5,
    y: 1.5,
    width: 45,
    height: 45
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#231F20",
    d: "M46.484,24v0.301c-0.027,1.949-0.289,3.922-0.84,5.813 c-0.512,1.891-1.297,3.711-2.32,5.395c-0.996,1.684-2.219,3.246-3.629,4.613c-1.395,1.379-2.996,2.567-4.707,3.504 c-1.711,0.98-3.547,1.711-5.453,2.18c-1.902,0.496-3.879,0.73-5.835,0.691c-1.961-0.016-3.922-0.289-5.812-0.844 c-1.891-0.523-3.711-1.297-5.395-2.316c-1.699-0.996-3.258-2.223-4.609-3.629C6.504,38.297,5.313,36.711,4.359,35 c-0.961-1.715-1.695-3.551-2.164-5.465c-0.496-1.895-0.73-3.867-0.691-5.824c0.016-1.961,0.293-3.922,0.844-5.813 c0.511-1.891,1.297-3.711,2.32-5.395c0.992-1.699,2.207-3.258,3.625-4.613C9.688,6.512,11.277,5.324,13,4.371 c1.711-0.965,3.551-1.695,5.453-2.18c1.906-0.48,3.863-0.718,5.836-0.687c1.96,0.012,3.921,0.301,5.812,0.855 c1.891,0.508,3.711,1.297,5.398,2.305c1.695,0.992,3.242,2.223,4.609,3.641c1.379,1.395,2.566,2.984,3.504,4.707 c0.98,1.699,1.711,3.547,2.18,5.453C46.262,20.273,46.512,22.133,46.484,24"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    points: "18.148,21.723 23.946,14.172 29.746,21.723 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.8753,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    points: "18.148,21.723  23.946,14.172 29.746,21.723 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.711,
    y: 22.219,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    width: 4.472,
    height: 11.703
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.711,
    y: 22.219,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.7721,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    width: 4.472,
    height: 11.703
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnUp);
export default __webpack_public_path__ + "static/media/btnUp.c6617474fcd1c3bf23145a049b554319.svg";
export { ForwardRef as ReactComponent };